import { fetchDevices } from 'aws-amplify/auth'

type AuthDevice = Awaited<ReturnType<typeof fetchDevices>>[number]
import { RootState } from 'src/redux/createRootReducer'

export const selectManageTrustedDevicesLoadingFromState = (
  state: RootState,
): boolean => state.app.profileSecurity.manageTrustedDevices.loading
export const selectManageTrustedDevicesTopLevelErrorFromState = (
  state: RootState,
): string | undefined =>
  state.app.profileSecurity.manageTrustedDevices
    .manageTrustedDevicesTopLevelError
export const selectManageTrustedDevicesDevicesFromState = (
  state: RootState,
): AuthDevice[] | undefined =>
  state.app.profileSecurity.manageTrustedDevices.devices
